import { lazy } from 'react';
/** Открывает список подписок */
export const SubscriptionsPageAsync = lazy(() => import('./Subscriptions/SubscriptionsPage'));